if (!customElements.get('share-button')) {
  customElements.define('share-button', class extends HTMLElement {
    connectedCallback() {
      this.elements = {
        shareButton: this.querySelector('button.share-button__button'),
        shareSummary: this.querySelector('summary.share-button__button'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        copyButton: this.querySelector('.share-button__copy')
      };

      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        // Hide the fallback <details>
        const details = this.querySelector('details');
        if (details) details.setAttribute('hidden', '');
        // Show the native share button
        if (this.elements.shareButton) {
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({
              title: document.title,
              url: this.urlToShare
            });
          });
        }
      } else {
        // Fallback logic
        const details = this.querySelector('details');
        if (details) {
          details.addEventListener('toggle', () => {
            if (!details.open) {
              this.elements.successMessage.classList.add('hidden');
              this.elements.successMessage.textContent = '';
              this.elements.closeButton.classList.add('hidden');
              this.elements.shareSummary.focus();
            }
          });
        }

        if (this.elements.copyButton) {
          this.elements.copyButton.addEventListener('click', () => {
            navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
              this.elements.successMessage.classList.remove('hidden');
              this.elements.successMessage.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied!';
              this.elements.closeButton.classList.remove('hidden');
              this.elements.closeButton.focus();
            });
          });
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', () => {
            const details = this.querySelector('details');
            if (details) details.open = false;
          });
        }
      }
    }

    updateUrl(url) {
      this.urlToShare = url;
      if (this.elements.urlInput) {
        this.elements.urlInput.value = url;
      }
    }
  });
}
